import i18n from '@/i18n'
import { DefectCategory, DefectCollectionType } from '@/utils/Enumerations.js'
import { tonStringFromPounds } from '@/utils/NumericMutations'

export function defectHeaders () {
  return [
    {
      value: 'name',
      text: i18n.t('name'),
      sortable: true
    },
    {
      value: 'defectLBS',
      text: i18n.t('defectTons'),
      align: 'right',
      sortable: true
    },
    {
      value: 'defaultPercentage',
      text: i18n.t('defaultPercentage'),
      align: 'right',
      sortable: true
    },
    {
      value: 'category',
      text: i18n.t('category'),
      align: 'center',
      sortable: true
    },
    {
      value: 'cut', // TODO MK
      text: i18n.t('cut'),
      align: 'center',
      sortable: false
    },
    {
      value: 'isActive',
      text: i18n.t('status'),
      sortable: true
    },
    {
      value: 'actions',
      text: i18n.t('actions'),
      align: 'center',
      sortable: false
    }
  ]
}

export function defectHeadersCsv () {
  return [
    {
      label: 'name',
      value: d => d.name
    },
    {
      label: 'category',
      value: d => DefectCategory.fromInt(d.category)
    },
    {
      label: 'defectPounds',
      value: d => d.defectLBS
    },
    {
      label: 'defaultPercentage',
      value: d => d.defaultPercentage
    },
    {
      label: 'lengthDeduction',
      value: d => d.lengthDeduction ? i18n.t('deductLength') : ''
    },
    {
      label: 'diameterDeduction',
      value: d => d.diameterDeduction ? i18n.t('deductDiameter') : ''
    },
    {
      label: 'volumeDeduction',
      value: d => d.volumeDeduction ? i18n.t('deductVolume') : ''
    }
  ]
}

export function diameterWeightsHeaders () {
  return [
    {
      text: i18n.t('diameter'),
      value: 'diameter'
    },
    {
      text: i18n.t('weight'),
      value: 'weight'
    }
  ]
}

export function ticketDefectFormHeaders () {
  return [
    {
      sortable: false,
      text: i18n.t('defectDefinitions'),
      value: 'name'
    },
    {
      sortable: false,
      text: i18n.t('category'),
      value: 'category',
      format: (value) => DefectCategory.fromInt(value)
    },
    {
      sortable: false,
      text: i18n.t('quantity'),
      value: 'quantity',
      align: 'center'
    }
  ]
}

export function ticketDefectHeaders (defectType = DefectCollectionType.Itemized.value) {
  const variableHeaders = defectType === DefectCollectionType.Itemized.value
    ? [
      { sortable: true, text: i18n.t('quantity'), value: 'quantity', align: 'right' }
    ]
    : [
      { sortable: true, text: i18n.t('diameter'), value: 'diameter', align: 'right' },
      { sortable: true, text: i18n.t('percentage'), value: 'percentage', align: 'right', format: (value) => `${value}%` }
    ]
  return [
    {
      sortable: true,
      text: i18n.t('name'),
      value: 'name'
    },
    {
      sortable: true,
      text: i18n.t('category'),
      value: 'category',
      format: (value) => DefectCategory.fromInt(value)
    },
    ...variableHeaders,
    {
      sortable: true,
      text: i18n.t('defectTons'),
      value: 'totalLBS',
      align: 'right',
      format: tonStringFromPounds
    }
  ]
}

export function ticketDefectCardHeader () {
  return [
    {
      sortable: true,
      text: i18n.t('name'),
      value: 'defect'
    },
    {
      sortable: true,
      text: i18n.t('quantity'),
      value: 'quantity',
      align: 'right'
    },
    {
      sortable: true,
      text: i18n.t('defectTons'),
      value: 'defectLBS',
      align: 'right'
    }
  ]
}
